import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useLoadingStore = defineStore('loading', () => {
  const loadingCount = ref(0)
  const isLoading = computed(() => loadingCount.value > 0)

  const show = () => {
    loadingCount.value++
  }

  const hide = () => {
    if (loadingCount.value > 0) {
      loadingCount.value--
    }
  }

  return {
    isLoading,
    loadingCount,
    show,
    hide
  }
})
